import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filteredRows: [],
  tableData: [],
  page: 0,
  rowsPerPage: 8,
  orderBy: 'ats_score',
  order: 'desc',
  jobDescription: '',
  score: '',
};

const atsMatchSlice = createSlice({
  name: 'atsMatch',
  initialState,
  reducers: {
    setFilteredRows(state, action) {
      state.filteredRows = action.payload;
    },
    setTableData(state, action) {
      state.tableData = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setRowsPerPage(state, action) {
      state.rowsPerPage = action.payload;
    },
    setOrder(state, action) {
      state.order = action.payload;
    },
    setOrderBy(state, action) {
      state.orderBy = action.payload;
    },
    setJobDescription(state, action) {
      state.jobDescription = action.payload;
    },
    setScore(state, action) {
      state.score = action.payload;
    },
    resetState(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setFilteredRows,
  setTableData,
  setPage,
  setRowsPerPage,
  setOrder,
  setOrderBy,
  setJobDescription,
  setScore,
  resetState,
} = atsMatchSlice.actions;

export default atsMatchSlice.reducer;
